module.exports = __webpack_public_path__ + "media/src/images/icons/list-marker-802b4e33089e66f63cb24cc3111e2c32.svg";